import { requests } from '../../../core/ajax'

export const ipCatalogoService = {
  /**
   * Devuelve lista de provincias con registros IP en el sistema.
   * @param {object} [params]
   * @param {string} [params.search] - texto parcial para filtrar por nombre
   * @returns {Promise<Array<{id: number, nombre: string}>>}
   */
  getProvincias: ({ search } = {}) =>
    requests
      .get('/inspecciones/catalogo/provincias', { params: { search } })
      .then((res) => res.data),

  /**
   * Devuelve lista de municipios con registros IP en el sistema.
   * @param {object} [params]
   * @param {string} [params.search] - texto parcial para filtrar por nombre
   * @param {string|string[]} [params.id_provincia] - IDs de provincia como "1,2,3" o array
   * @returns {Promise<Array<{id: number, nombre: string}>>}
   */
  getMunicipios: ({ search, id_provincia } = {}) => {
    const params = { search }
    if (id_provincia) {
      params.id_provincia = Array.isArray(id_provincia) ? id_provincia.join(',') : id_provincia
    }
    return requests.get('/inspecciones/catalogo/municipios', { params }).then((res) => res.data)
  },

  /**
   * Devuelve lista de plantillas disponibles.
   * Endpoint actual: GET /ai_template_empresa
   * Devuelve: [{ empresa: {...}, template: { id, wordpos_table, ... } }]
   * Se mapea a { key: template.id, value: template.wordpos_table }
   */
  getPlantillas: () =>
    requests.get('/ai_template_empresa').then((res) =>
      res.data.map((item) => ({
        key: item.id,
        value: item.nombre,
      }))
    ),
}
